module.exports = __webpack_public_path__ + "static/media/mysql-logo-svgrepo-com.3680f066.svg";